import PropTypes from 'prop-types';
// @mui
import { Typography, ListItemText, ListItemAvatar, ListItemButton, Box } from '@mui/material';
// utils
// components
import Iconify from 'src/components/iconify';
import { glb_sv } from 'src/utils';
import { t } from 'i18next';
import moment from 'moment';
import crypt from 'src/utils/service/crypt';
import { useNavigate } from 'react-router-dom';
import { memo } from 'react';
import { renderContent } from './renderContent';

const NotificationItem = ({ notification, handleClose }) => {
    const { avatar, title } = renderContent(notification);
    // console.log(notification);
    const navigate = useNavigate();
    const handleNavige = (data) => {
        const menu = sessionStorage.getItem('menu');
        let idImportWareHouse = {};
        let idBorow = {};
        let idManagerDevice = {};
        let idGiver = {};
        let idTake = {};
        if (menu) {
            try {
                const data = JSON.parse(crypt.deCode(menu));
                idImportWareHouse = data[0].filter((item) => item.screens_key === 'nhap_xuat_tb')[0];
                idBorow = data[0].filter((item) => item.screens_key === 'ds_muon_tb')[0];
                idManagerDevice = data[0].filter((item) => item.screens_key === 'lay_muon_tb')[0];

                idGiver = data[0].filter((item) => item.screens_key === 'tra_thiet_bi')[0];
                idTake = data[0].filter((item) => item.screens_key === 'ds_lay_tb')[0];
            } catch (error) {}
        }

        if (data?.key_funct) {
            if (data.key_funct === 'er1' || data.key_funct === 'iwh' || data.key_funct === 'ewh') {
                const dataSs = {
                    cabinet: { cabinet_nm: data?.cabinet_nm, id: data?.cabinet_id ? data?.cabinet_id : 0 },
                    drawer: { drawer_nm: data?.drawer_nm, id: data?.drawer_id ? data?.drawer_id : 0 },
                };
                // console.log(data)
                sessionStorage.setItem('dataCabinet', JSON.stringify(dataSs));
                navigate(
                    '/home/group/manager-devices/' + idImportWareHouse.id + '/manager-devices/' + data.group_dv_id
                );
                handleClose && handleClose();
            }
            if (data.key_funct === 'er2') {
                navigate('/home/group-device/' + idManagerDevice.id + '/devices/' + data.group_dv_id);
                handleClose && handleClose();
            }
            if (data.key_funct === 'er3' || data.key_funct === 'igb') {
                navigate('/home/give-back-device/' + idGiver.id);
                handleClose && handleClose();
            }
            if (data.key_funct === 'ebr') {
                navigate('/home/list-give-device/' + idBorow.id);
                handleClose && handleClose();
            }
            if (data.key_funct === 'etk') {
                navigate('/home/list-get-device/' + idTake.id);
                handleClose && handleClose();
            }
        }
    };
    return (
        <ListItemButton
            sx={{
                py: 1.5,
                px: 2.5,
                mt: '1px',
                ...(notification.status_notify !== '1' && {
                    bgcolor: 'action.selected',
                }),
            }}
        >
            <ListItemAvatar>
                {notification?.pic_device ? (
                    <img
                        style={{
                            width: '60px',
                            height: '60px',
                            borderRadius: '5px',
                            backgroundColor: (theme) => theme.palette['primary'].lighter,
                        }}
                        src={`${glb_sv.urlGetProductImage(notification?.pic_device)}`}
                        alt=""
                    />
                ) : (
                    <div
                        style={{
                            width: '60px',
                            height: '60px',
                            borderRadius: '5px',
                            border: '1px solid #ccc',
                            backgroundColor: (theme) => theme.palette['primary'].lighter,
                        }}
                    ></div>
                )}
            </ListItemAvatar>
            {notification?.type_noty === '1' ? (
                <ListItemText
                    primary={title}
                    onClick={() => handleNavige(notification)}
                    secondary={
                        <>
                            <Typography
                                paddingLeft={2}
                                variant="caption"
                                sx={{
                                    mt: 0.5,
                                    display: 'flex',
                                    // alignItems: 'center',
                                    color: 'text.warning',
                                }}
                            >
                                <Iconify
                                    icon="material-symbols:warning-outline-rounded"
                                    sx={{ mr: 0.5, width: 16, height: 16 }}
                                />
                                {notification?.key_mean}{' '}
                                {notification?.key_funct === 'er3'
                                    ? '.' +
                                      ' ' +
                                      t('day_give') +
                                      ' ' +
                                      moment(notification.return_date, 'YYYYMMDD').format('DD/MM/YYYY')
                                    : ''}
                            </Typography>
                        </>
                    }
                />
            ) : (
                <>
                    <ListItemText
                        primary={title}
                        onClick={() => handleNavige(notification)}
                        secondary={
                            <Typography
                                paddingLeft={2}
                                variant="caption"
                                sx={{
                                    mt: 0.5,
                                    display: 'flex',
                                    alignItems: 'center',
                                    color: 'text.disabled',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                }}
                            >
                                <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                                    <Iconify icon="eva:clock-outline" sx={{ mr: 0.5, width: 16, height: 16 }} />
                                    {glb_sv.formatDate(notification?.transaction_dt, 'YYYYMMDDHHmmss')}
                                </Box>
                                {notification?.user_nm && (
                                    <Box sx={{ display: 'flex', gap: 1 }}>
                                        <Iconify
                                            icon="material-symbols:person-outline-rounded"
                                            sx={{ mt: 0.1, width: 16, height: 16 }}
                                        />
                                        {notification?.user_nm}
                                    </Box>
                                )}
                            </Typography>
                        }
                    />
                </>
            )}
        </ListItemButton>
    );
};


NotificationItem.propTypes = {
    notification: PropTypes.shape({
        createdAt: PropTypes.instanceOf(Date),
        id: PropTypes.string,
        isUnRead: PropTypes.bool,
        title: PropTypes.string,
        description: PropTypes.string,
        type: PropTypes.string,
        avatar: PropTypes.any,
    }),
};


export default memo(NotificationItem);
